import Building from "@/views/building";
import { getCurrentInstance } from "vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const store = getCurrentInstance()?.proxy?.$store;

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    redirect: {
      name: "app",
    },
  },
  {
    path: "/app/outer",
    name: "app",
    component: () => import("../views/outer-frame/index"),
    redirect: { name: "app-root" },
    children: [
      {
        path: "",
        name: "app-root",
        component: Building,
      },
      {
        path: "home",
        name: "home",
        children: [
          {
            path: "",
            name: "home-root",
            meta: { title: "渲沅山庄-UUID" },
            component: () => import("../views/home/index"),
          },
        ],
      },
      {
        path: "online-tools",
        name: "online-tools",
        children: [
          {
            path: "uuid",
            name: "online-tools-uuid",
            meta: { title: "渲沅山庄-UUID" },
            component: () => import("../views/online-tools/uuid"),
          },
          {
            path: "base64",
            name: "online-tools-base64",
            meta: { title: "渲沅山庄-BASE64" },
            component: () => import("../views/online-tools/base64"),
          },
          {
            path: "md5",
            name: "online-tools-md5",
            meta: { title: "渲沅山庄-MD5" },
            component: () => import("../views/online-tools/md5"),
          },
          {
            path: "random",
            name: "online-tools-random",
            meta: { title: "渲沅山庄-随机字符串" },
            component: () => import("../views/online-tools/random-string"),
          },
          {
            path: "timestamp",
            name: "online-tools-timestamp",
            meta: { title: "渲沅山庄-时间戳" },
            component: () => import("../views/online-tools/timestamp"),
          },
          {
            path: "json-format",
            name: "online-tools-json-format",
            meta: { title: "渲沅山庄-JSON格式化" },
            component: () => import("../views/online-tools/json-format"),
          },
          {
            path: "xml-format",
            name: "online-tools-xml-format",
            meta: { title: "渲沅山庄-XML格式化" },
            component: () => import("../views/online-tools/xml-format"),
          },
          {
            path: "html-format",
            name: "online-tools-html-format",
            meta: { title: "渲沅山庄-HTML格式化" },
            component: () => import("../views/online-tools/html-format"),
          },
          {
            path: "radix",
            name: "online-tools-radix",
            meta: { title: "渲沅山庄-进制互转" },
            component: () => import("../views/online-tools/radix-conversion"),
          },
          {
            path: "unicode",
            name: "online-tools-unicode",
            meta: { title: "渲沅山庄-Unicode编码" },
            component: () => import("../views/online-tools/unicode"),
          },
          {
            path: "encryption",
            name: "online-tools-encryption",
            redirect: { name: "online-tools-encryption-aes" },
            children: [
              {
                path: "aes",
                name: "online-tools-encryption-aes",
                meta: { title: "渲沅山庄-AES加解密" },
                component: () => import("../views/online-tools/encryption/aes"),
              },
              {
                path: "des",
                name: "online-tools-encryption-des",
                meta: { title: "渲沅山庄-DES加解密" },
                component: () => import("../views/online-tools/encryption/des"),
              },
              {
                path: "rsa",
                name: "online-tools-encryption-rsa",
                meta: { title: "渲沅山庄-RSA加解密" },
                component: () => import("../views/online-tools/encryption/rsa"),
              },
              {
                path: "sha",
                name: "online-tools-encryption-sha",
                meta: { title: "渲沅山庄-SHA哈希" },
                component: () => import("../views/online-tools/encryption/sha"),
              },
            ],
          },
          {
            path: "word-count",
            name: "online-tools-word-count",
            meta: { title: "渲沅山庄-文本字数统计" },
            component: () => import("../views/online-tools/word-count"),
          },
          {
            path: "url-encode",
            name: "online-tools-url-encode",
            meta: { title: "渲沅山庄-URL编码/解码" },
            component: () => import("../views/online-tools/url-encode"),
          },
          // 新增工具
          {
            path: "regex-tester",
            name: "online-tools-regex-tester",
            meta: { title: "渲沅山庄-正则表达式测试器" },
            component: () => import("../views/online-tools/regex-tester"),
          },
          {
            path: "cron-expression",
            name: "online-tools-cron-expression",
            meta: { title: "渲沅山庄-Cron表达式生成器" },
            component: () => import("../views/online-tools/cron-expression"),
          },
          {
            path: "properties-yaml",
            name: "online-tools-properties-yaml",
            meta: { title: "渲沅山庄-Properties/YAML互转" },
            component: () => import("../views/online-tools/properties-yaml"),
          },
          {
            path: "ascii-table",
            name: "online-tools-ascii-table",
            meta: { title: "渲沅山庄-ASCII码速查表" },
            component: () => import("../views/online-tools/ascii-table"),
          },
          {
            path: "color-convert",
            name: "online-tools-color-convert",
            meta: { title: "渲沅山庄-颜色格式转换" },
            component: () => import("../views/online-tools/color-convert"),
          },
          {
            path: "qrcode-generator",
            name: "online-tools-qrcode-generator",
            meta: { title: "渲沅山庄-QR码生成器" },
            component: () => import("../views/online-tools/qrcode-generator"),
          },
          {
            path: "jwt-decoder",
            name: "online-tools-jwt-decoder",
            meta: { title: "渲沅山庄-JWT解码器" },
            component: () => import("../views/online-tools/jwt-decoder"),
          },
          // {
          //   path: "city",
          //   name: "online-tools-city",
          //   meta: {
          //     title: "渲沅山庄-行政区划",
          //   },
          //   component: () =>
          //     import("../views/online-tools/administrative-division"),
          // },
        ],
      },
      {
        path: "dev-course",
        name: "dev-course",
        redirect: { name: "dev-course-home" },
        children: [
          {
            path: "",
            name: "dev-course-home",
            meta: { title: "渲沅山庄-开发教程" },
            component: () => import("../views/dev-course/index"),
          },
          {
            path: ":trackSlug",
            name: "dev-course-track",
            meta: { title: "渲沅山庄-教程体系" },
            component: () => import("../views/dev-course/track-detail"),
          },
          {
            path: "learn/:trackSlug/:courseSlug?/:articleSlug?",
            name: "dev-course-learn",
            meta: { title: "渲沅山庄-教程学习" },
            component: () => import("../views/dev-course/learn"),
          },
        ],
      },
      {
        path: "404",
        name: "404",
        component: Building,
      },
    ],
  },
  // {
  //   path: '/app/uuus',
  //   name: 'uuus',
  //   component: () => import('../views/inner-frame/index.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: "/:pathMatch(.*)",
    redirect: {
      name: "404",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title =
    to?.meta?.title || store?.state?.common?.title || "渲沅山庄-欢迎光临";
  next();
});

export default router;
